<template>
  <div :class="elementClasses">
    <form-label :label="label"
                :label-classes="labelClasses"
                :popover-text="popoverText"></form-label>

    <div :class="inputClasses">
      <select class="form-control"
              :class="{'is-invalid': error}"
              :disabled="disabled"
              v-model="value_">
        <slot name="options"></slot>
      </select>

      <div v-show="error" class="invalid-feedback">
        {{ error }}
      </div>
    </div>
  </div>
</template>

<script>
  import FormLabel from './FormLabel'

  export default {
    props: {
      inputClasses: {
        type: String,
        default: 'col-8 col-xl-9'
      },
      labelClasses: {
        type: String,
        default: 'col-4 col-xl-3 text-muted col-form-label'
      },
      elementClasses: {
        type: String,
        default: 'row form-group'
      },
      error: [String, Boolean],
      label: {
        type: String,
        required: false
      },
      popoverText: String,
      value: {
        required: true
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },

    components: {
      'form-label': FormLabel
    },

    data() {
      return {
        value_: this.value,
        popoverTextId: null
      }
    },

    watch: {
      value_(val) {
        this.$emit('form-select', val)
      }
    }
  }
</script>

<style scoped>

</style>
